module.exports = __webpack_public_path__ + "img/Distribution-of-Packages-by-Continent-1024x878.08f26c10.png";